module.exports = __webpack_public_path__ + "static/media/Inspect_Route.660b7a0a.svg";